<template>
  <b-container class="tx_class" v-if="has_deleted_node">
    <b-row no-gutters style="justify-content: space-around;">
      <b-col cols=3><span cols=1 style="color: blue; text-align: right; margin-right: 5px;">[Buy]</span><CurrencyAmount v-bind:amount="pays" /></b-col>
      <b-col cols=3><span style="color: red; text-align: right; margin-right: 5px;">[Sell]</span><CurrencyAmount v-bind:amount="gets" /></b-col>
    </b-row>
  </b-container>

  <div v-else>
    Cancelled Offer {{sequence}}
  </div>
</template>

<script>
import CurrencyAmount from '../CurrencyAmount.vue'

var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'OfferCancelTx',

  mixins : [HasTx],

  components : {
    CurrencyAmount
  },

  computed : {
    sequence : function(){
      return this.tx_obj["OfferSequence"];
    },

    deleted_node : function(){
      if(!this.tx_meta)
        return null;

      for(var n = 0; n < this.tx_meta["AffectedNodes"].length; n += 1)
        if(this.tx_meta["AffectedNodes"][n]["DeletedNode"] &&
           this.tx_meta["AffectedNodes"][n]["DeletedNode"]["LedgerEntryType"] == "Offer")
          return this.tx_meta["AffectedNodes"][n]["DeletedNode"]["FinalFields"];

      return null;
    },
 
    has_deleted_node : function(){
      return !!this.deleted_node;
    },

    gets : function(){
      return this.deleted_node["TakerGets"];
    },

    pays : function(){
      return this.deleted_node["TakerPays"];
    }
  }
}
</script>

<style scoped>
</style>
